import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";

import { Table, Pagination } from "antd";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { formatDateHandler2, toTitleCase } from "utils/common";

import { SkeltonLoader } from "components/skeltonLoader";

import Image from "components/Image";
import AddJobModal from "components/Administration/Jobs/ManageJobs/AddJobModal";
import { toast, Bounce } from "react-toastify";
import { deleteDocumentApi } from "api/services/documents";
import { Button } from "components/Button";

import {getAllDocumentApi, getAllDocumentTypeApi} from "api/services/documents"
import { useSearchParams } from 'react-router-dom';

import {  useNavigate } from "react-router-dom";
import {format} from "date-fns"
import { filterHandler } from 'utils/common';
import { useMediaQuery } from "react-responsive";





const AllDocuments = ({userData}) => {

    const [searchParams, setSearchParams] = useSearchParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const [documentModal, setDocumentModal] = useState(false);
  const [ selectedDocument, setSelectedDocument] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [storeType, setStoreType] = useState("user");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [documentType, setDocumentType] = useState([])
  const [documentTypeLoading, setDocumentTypeLoading] = useState(false)

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",
    document_type: searchParams.get("document_type") ,
    // document_sub_type: searchParams.get("document_sub_type") ,
    user: searchParams.get("company_user")

    //document_type=user&document_sub_type=passport&user=1&issue_date_after=2025-10-28&issue_date_before=2025-10-29&expiry_date_after=2025-10-30&expiry_date_before=2025-10-30&sort_type=ascend&sort_by=issue_date&expiry_in=365
})


// const getFilterParams = useCallback(()=>{
//   let filter_params = filterHandler(filters)
//     return filter_params
        
// })

const setDocumentParams = (pageData) => {
    // let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        // ...filter_params
    }
    setSearchParams(params)
}



    const getDocumentList = () => {
        setLoading(true)
        // setFilterLoading(true)      
        // let filter_params = getFilterParams()
        let filter_params = {}
          if(filter_params?.issue_date_after){
            filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.issue_date_before){
          filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
         }

        if(filter_params?.expiry_date_after){
            filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.expiry_date_before){
            filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
        }


        console.log(userData, "&&&&&&&&&&&&&&&")
          
        getAllDocumentApi({         
        company_user: userData?.id,
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          employee: pageSettings?.employee,
          document_type: pageSettings?.document_type,
          document_sub_type: pageSettings?.document_sub_type,
        //   company_user: pageSettings?.userData,
          document_type__type: storeType,
          ...filter_params    
        }).then(response=>{
          if(view=="grid" && pageSettings?.page!==1){
            setDocumentData([...documentData,...response.data.results]);

          }else{
            setDocumentData(response.data.results);

          }

          
          setPageSettings({
            ...pageSettings,
            total: response.data.count
          })
    
          setLoading(false)
        //   setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{
    if(userData?.id){
      getDocumentList()
    }

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, storeType, userData])

  useEffect(()=>{
    // setDocumentParams(pageSettings)
  },[pageSettings])

  useEffect(()=>{
    setDocumentTypeLoading(true)
    getAllDocumentTypeApi({type:storeType}).then(response=>{
      setDocumentType(response.data.results)
      setDocumentTypeLoading(false)
    }).catch(e=>{
      setDocumentTypeLoading(false)
    })
  },[storeType])

//   const handleApplyFilter = () => {
//     setPageSettings({
//         ...pageSettings,
//         page: 1,
//         // filters
//       })

//   }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  




  const handleDocumentDetailPage = (id, index) => {			  
    navigate(`/documents/${id}`)
    setSelectedPage(index)
  }


  const columns = [
    {
      title: "Employee Name",
      dataIndex: "first_name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          <a
            onClick={() => handleDocumentDetailPage(record.id, index)}
            className="avatar"
          >
            <Image src={record.company_user?.profile_image} type="user" style={{ objectFit: "cover" }} />
          </a>
          <a
            onClick={() => handleDocumentDetailPage(record.id, index)}
            className="profile-split d-flex flex-column"
          >
            {record.company_user?.first_name} {record.company_user?.last_name}{" "}
            <span className="small text-muted">
              {record.company_user?.emp_no}
            </span>
          </a>
        </h2>
      ),
    },
 
    {
      title: "Document Name",
      dataIndex: "name",
      render: (text, record) => (
        <div className="profile-split d-flex flex-column">
          <span className="table-avatar">{record.name}</span>
         
        </div>
      ),
    },

    // {
    //   title: "Document No",
    //   dataIndex: "document_number",
    //   render: (text, record) => (
    //     <span className="table-avatar">{record.document_number}</span>
    //   ),
    // },

    {
      title: "Type",
      dataIndex: "document_sub_type",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span className="badge badge-soft-info">
            {record.document_type?.name}
          </span>
        </div>
      ),
    },

    {
 title: "Attachments",
      dataIndex: "document_sub_type",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
        <span className="small text-muted">
              {" "}
              <i class="fa-solid fa-paperclip" /> {record.attachments_count}{" "}
              Attachments{" "}
            </span>
        </div>
      ),
    },
    

    {
      title: "Issue Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.issue_date)}
        </span>
      ),
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.expiry_date)}
        </span>
      ),
    },
    {
      title: "Expires In",
      dataIndex: "expiry_notify_in_days",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <span className="table-avatar">{record.expiry_in_days}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_expired",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span
            className={`badge badge-soft-${
              record.is_expired ? "danger" : "success"
            }`}
          >
            {record.is_expired ? "Expired" : "Active"}
          </span>
        </div>
      ),
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )

    // },
    {
      title: "Action",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link
            onClick={()=>{
              handleEditDocument(recort)
              setDocumentModal(true)
              // setSelectedDocument(record)

            }}
              // to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_job"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link> */}
            {/* <Link
              onClick={() => {
                setDeleteModal(true);
                setSelectedDocument(record);
              }}
              to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link> */}
          </div>
        </div>
      ),
    },
  ];
  useEffect(()=>{
    setStoreType("user")
  },[])
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {documentData.map((document, index) => (
            <div
            // onClick={() => handleDocumentDetailPage(document.id, index)}
              className="col-md-6 col-sm-1 col-12 col-lg-3 col-xl-4"
              key={document.id}
            >
              <div className="profile-widget">
                <div className="dropdown profile-action">
                  <Link
                    
                    //   to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons">more_vert</i>
                  </Link>

                  <div className="dropdown-menu dropdown-menu-right">
                    {/* <Link
                      className="dropdown-item"
                      onClick={() => handleDocumentDetailPage(record.id, index)}
                      // to="#"
                      //  data-bs-toggle="modal"
                      //  data-bs-target="#edit_resume"
                    >
                      <i className="fa fa-pencil m-r-5" /> Edit
                    </Link> */}
                    {/* <Link
                      className="dropdown-item"
                      onClick={() => {
                        // setDeleteModal(true);
                        setSelectedDocument(document);
                      }}
                      // to="#"
                      //data-bs-toggle="modal"
                      // data-bs-target="#delete"
                    >
                      <i className="fa-regular fa-trash-can m-r-5" /> Delete
                    </Link> */}
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                      <a
                        onClick={() =>
                          handleDocumentDetailPage(document.id, index)
                        }
                      >
                        {document?.company_user?.first_name} {"  "}{" "}
                        {document?.company_user?.last_name}
                      </a>
                    </h4>

                    <div className="m-t-10 small text-muted text-start">
                      {document?.company_user?.email}
                    </div>
                    <div className="small text-muted text-start">
                      {document?.company_user?.position_name}
                    </div>

                    <div className="small text-muted text-start">
                      {document?.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

 

  return (
    <>
        <div className="content container-fluid">
          

          {view == "grid" ? (
            <div className="row">
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={documentData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}


        </div>
   

   
    </>
  );
};

export default AllDocuments;
